import { z } from "zod";

import { COGNITO_ADMIN_GROUP, COGNITO_AUTOMATION_GROUP } from "@recobra/core";

const TaskEmailStatus = z.enum(["sent", "skipped", "bounced", "complained"]);

export const TaskEmailSchema = z.object({
  id: z.uuid().meta({ visibleTo: "*" }),
  kind: z
    .enum(["task.assigned"])
    .describe("Which communication this email is; future task emails add kinds")
    .meta({ visibleTo: "*" }),
  recipientUsername: z.string().min(1).meta({ visibleTo: "*" }),
  status: TaskEmailStatus.describe(
    "`skipped` when this environment has no sender; `bounced` and `complained` come from " +
      "provider feedback",
  ).meta({ visibleTo: "*" }),
  sesMessageId: z
    .string()
    .min(1)
    .optional()
    .describe("Provider message id, used to match bounce and complaint feedback")
    .meta({ visibleTo: [COGNITO_ADMIN_GROUP] }),
  createdBy: z.string().min(1).meta({ visibleTo: "*" }),
  createdAt: z.iso
    .datetime()
    .describe("When the provider accepted the email, or it was skipped")
    .meta({ visibleTo: "*" }),
  dedupeKey: z
    .string()
    .max(200)
    .optional()
    .meta({ visibleTo: [COGNITO_ADMIN_GROUP, COGNITO_AUTOMATION_GROUP] }),
});
export type TaskEmail = z.infer<typeof TaskEmailSchema>;

export const SendTaskAssigneeEmailSchema = z.discriminatedUnion("trigger", [
  z.object({
    trigger: z.literal("assignment"),
    expectedAssignee: z
      .string()
      .min(1)
      .describe("The assignee the signal saw; the email is skipped when the task has moved on"),
    dedupeKey: z.string().trim().min(1).max(200),
  }),
  z.object({ trigger: z.literal("manual") }),
]);
export type SendTaskAssigneeEmailInput = z.infer<typeof SendTaskAssigneeEmailSchema>;
